import moment from 'moment'

const formatDate = function (value) {
  if (value) {
    return moment(value).format('YYYY-MM-DD')
  }
}

const formatDateTime = function (value) {
  if (value) {
    return moment(value).format('YYYY-MM-DD HH:mm')
  }
}

const fullAddress = function (address) {
  if (!address) {
    return ''
  }
  const arr = []
  if (address.address) {
    arr.push(address.address)
  }
  if (address.postalCode) {
    arr.push(address.postalCode)
  }
  if (address.city) {
    arr.push(address.city)
  }
  return arr.join(' ')
}

export default { formatDate, formatDateTime, fullAddress }
